export default __webpack_public_path__ + "static/media/close-30px-3f3e3c.c0804ff5.svg";